export const configLanguages = {
    en: {
        plans_page: 'plans/',
    },
    ar: {
        plans_page: 'ar/plans/',
    },
    de: {
        plans_page: 'de/plans/',
    },
    el: {
        plans_page: 'el/plans/',
    },
    es: {
        plans_page: 'es/planes/',
    },
    fr: {
        plans_page: 'fr/plans/',
    },
    he: {
        plans_page: 'he/plans/',
    },
    id: {
        plans_page: 'id/plans/',
    },
    it: {
        plans_page: 'it/plans/',
    },
    ja: {
        plans_page: 'ja/plans/',
    },
    ko: {
        plans_page: 'ko/plans/',
    },
    ms: {
        plans_page: 'ms/plans/',
    },
    nl: {
        plans_page: 'nl/plans/',
    },
    no: {
        plans_page: 'no/plans/',
    },
    pl: {
        plans_page: 'pl/plans/',
    },
    pt: {
        plans_page: 'pt/plans/',
    },
    ru: {
        plans_page: 'ru/plans/',
    },
    tr: {
        plans_page: 'tr/plans/',
    },
    uk: {
        plans_page: 'uk/plans/',
    },
    vi: {
        plans_page: 'vi/plans/',
    },
    zh: {
        plans_page: 'zh/plans/',
    }
};
